import React, { useRef, useState, useContext, useEffect } from "react";
import { Global } from "../../context/globalContextProvider";
// import { eventViewPromotion, eventSelectPromotion } from "../../utilities/dataLayer";
import useListenDataPersonalise from "../../hooks/useListenDataPersonalised";
import { getUrlParameterBykey } from "../../utilities/urlHelper";
import "../../assets/styles/components/_selectInput.scss";
import {
  APPLE_PAY_LABEL,
  PAYPAL_LABEL,
  CREDIT_CARD_LABEL,
  CONTRIBUTOR_INDIVIDUAL,
  CONTRIBUTOR_ORGANISATION,
  DONATIONFREEUENCY_ONCE,
  DONATIONFREQUENCY_MONTHLY,
} from "../../utilities/constants";

const SelectInput = ({
  selectorgroup, //originally dataLayer
  disabled = false,
  defaultOptions,
  defaultValue,
  onClickCallBack: parentOnClickCallBack = null,
  show = true,
  // setDonationAmount = null,
  // donationFixedProcessingCost,
  // donationAmount, //passed by globalContext
  // tags = [],
}) => {
  const {
    // updateDonation, //removed by implementing the logic here using setDonationAmount
    setPaymentMethod, //setPayments
    // setChecked,
    // donationAmount,
    // setDonationAmount,
    donationFrequency, //selectionTab
    setDonationFrequency, //setSelectionTab
    setContributor, //setContributer
    setActiveSelection,
  } = useContext(Global);

  const selectInputRef = useRef(null); //use to call selector
  const [options, setOptions] = useState(defaultOptions);
  const [selection, setSelection] = useState(defaultValue);

  //Sync the donationFrequency with the selection
  useEffect(() => {
    if ([DONATIONFREEUENCY_ONCE, DONATIONFREQUENCY_MONTHLY].includes(defaultValue)) {
      setSelection(donationFrequency);
    }
  }, [donationFrequency, setSelection, defaultValue]);

  /**
   *
   * @param {string} selection
   * @param {boolean} onMounted if true means it's called when mounting the component
   */
  const onUpdateSelection = (selection, callBack = null) => {
    if ([CREDIT_CARD_LABEL, PAYPAL_LABEL, APPLE_PAY_LABEL].includes(selection)) {
      setPaymentMethod(selection);
    } else if ([DONATIONFREEUENCY_ONCE, DONATIONFREQUENCY_MONTHLY].includes(selection)) {
      setDonationFrequency(selection);
    } else if ([CONTRIBUTOR_INDIVIDUAL, CONTRIBUTOR_ORGANISATION].includes(selection)) {
      setContributor(selection);
    }
    // original:
    // setPayments(selection);
    // if (selection === "once" || selection === "monthly") {
    //  setSelectionTab(selection);
    // }
    // if (selection === "individual" || selection === "organisation") {
    //     setContributer(selection);
    // }
    // comments:
    // setPayments should really been setPaymentMethod, and it should always execute when the option is setPaymentMethod
    // setSelectionTab is renamed to setDonationFrequency to make more understandable
    // setContributor is the same
    // the constants are tiled to contentful and dynamics, so using a fixed constant makes more sense

    //added:
    setActiveSelection(selection); //used by global logical fields to controll show/hide of fields

    setSelection(selection); // update selection regardless
    // original:
    // const personalisedOptions = selectInputRef.current.dataset.personalised;
    // if (personalisedOptions !== "false") {
    //   setOptions(JSON.parse(personalisedOptions));
    // } else {
    //   setSelection(selection);
    // }
    // comments:
    // doesn't make sense to update the personalised when user click on the button, this should only be updated by the useListenDataPersonalise hook

    // removed, because amount-selector should be handled separately
    //for amount-selector
    // if (setDonationAmount) {
    //   if (donationFixedProcessingCost === 0) setChecked(false);
    //   // setChecked(false);
    //   if (!onMounted) eventSelectPromotion(selection);
    //   // console.log('selection', selection, options, donationFrequency, tags, defaultValue);
    //   const cleanedDonationAmount = selection.replace(/\$/g, "").trim();
    //   setDonationAmount(cleanedDonationAmount);
    //   //updateDonation(selection);
    // }

    if (typeof callBack === "function") callBack(selection);
    // original:
    // if (onClick && !onMounted) onClick(selection);
    // comments:
    // using a boolean to determine if need to call a parent callback, update it to a direct pass of callback, makes the code more readable
  };

  // Setting defaultValue by URL params, should only run once when mounting the component
  useEffect(
    function setDefaultValueByUrlParams() {
      const select = getUrlParameterBykey("selection", null); //this should only be "once" or "monthly", judging from original code logic
      // original:
      // const query = newURLSearchParams(window.location.search);
      // const select = query.get("selection");

      if (select && [DONATIONFREEUENCY_ONCE, DONATIONFREQUENCY_MONTHLY].includes(defaultValue)) {
        onUpdateSelection(select); //always call parent callback, so other select can update
        setTimeout(() => parentOnClickCallBack(select), 100);
      } else {
        onUpdateSelection(defaultValue);
      }
      // original:
      // if (
      //     (defaultValue === "once" || defaultValue === "monthly") &&
      //     select !== null
      //   ) {
      //     defaultValue = select;
      //     // console.log(defaultValue);
      //     updateSelection(defaultValue);
      //     setPayments(defaultValue);
      //   }
      // comments:
      // updateSelection would been called regardless of
      // console.log("tempDefaultValue", tempDefaultValue);
      // onUpdateSelection(tempDefaultValue, parentOnClickCallBack);
      // original:
      //   if (defaultValue) {
      //     updateSelection(defaultValue);
      //     setPayments(defaultValue);
      //   }
      // comments:
      // write it in a separate useEffect
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [defaultValue]
  );

  const isActive = (option) => {
    // moved to AmountSelector
    // if (donationAmount) {
    // return option.replace(/\$/g, "").trim() === donationAmount; //for amount-selector
    // } else {
    return option === selection;
    // }
  };
  // for moved to AmountSelector
  // useEffect(() => {
  // if (setDonationAmount !== null && !disabled) {
  // eventViewPromotion(options, tags[0]);
  // }
  // }, [disabled, tags, setDonationAmount]);

  useListenDataPersonalise(selectInputRef, setOptions, options);
  useCheckApplyPayCompatiablity(donationFrequency, setOptions, options);
  // console.log("show: ", show);

  return (
    <div
      className="selector"
      selectorgroup={selectorgroup ?? ""} //   selectorgroup={dataLayer ? dataLayer : ""}
      disabled={disabled}
      ref={selectInputRef}
      data-personalised="false"
      style={show === false ? {display: "none"} : {}}
    >
      {options.map((option, index) => (
        <button
          type="button"
          className={`selector__button ${isActive(option) ? "active" : ""}`}
          onClick={() => {
            onUpdateSelection(option, parentOnClickCallBack);
          }}
          key={`selector-button-${index}`}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default SelectInput;

// custom hooks

//adding "Apple pay" to payment method, when compatiable
//options, setOptions update shoud not trigger the useEffect, so it's safe to use it here
const useCheckApplyPayCompatiablity = (donationFrequency, setOptions, options) => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (options.includes(CREDIT_CARD_LABEL) || options.includes(PAYPAL_LABEL)) {
      if ((typeof window.ApplePaySession === "undefined" && options.includes(APPLE_PAY_LABEL)) || donationFrequency === DONATIONFREQUENCY_MONTHLY) {
        setOptions(options.filter((option) => option !== APPLE_PAY_LABEL));
      } else if (
        typeof window.ApplePaySession !== "undefined" &&
        !options.includes(APPLE_PAY_LABEL) &&
        donationFrequency === DONATIONFREEUENCY_ONCE
      ) {
        setOptions([...options, APPLE_PAY_LABEL]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [donationFrequency]);
};
